<div *ngIf="isLoading | async" class="overlay">
  <mat-spinner class="spinner_loader"></mat-spinner>
</div>
